// String values MUST match the backend enum member names: the public API registers a
// JsonStringEnumConverter (Public.Api Startup.cs), so SearchState serializes as
// "Created"/"Completed"/"Deleted", not 1/2/3. With numeric values here, every
// `state === CompanySearchState.Completed` check silently failed (string !== number),
// so completed searches showed the "high volume" modal forever and never rendered results.
export enum CompanySearchState {
    Created = 'Created',
    Completed = 'Completed',
    Deleted = 'Deleted',
}

export interface SavedCompaniesListModel {
    count: number;
    list: CompanyListItemModel[];
}

export interface CompanyListItemModel {
    savedCompanyId?: number;
    shortName?: string;
    fullName: string;
    countryOfFoundation: string;
    industry: string;
    totalNetRevenues?: string;
}

export interface SavedCompanySearch {
    id: number;
    name: string;
    resultCount: number;
    searchParameters: string[];
    spentCredits: number;
    state: CompanySearchState;
}

export interface SavedCompany {
    savedCompanyId: number;
    totalNetRevenues: string;
    countryOfFoundation: string;
    industry: string;
    fullName: string;
    shortName?: string;
    updatesAvailable: number;
}

export interface SearchResultsTabsHeader {
    savedCompanies: number;
    uploadedCompanies: number;
    savedSearchResults: number;
    userId: number;
}